import { withInstall } from '@code-monkey-ui/utils'
import TreeV2 from './src/tree.vue'

export const ElTreeV2 = withInstall(TreeV2)
export default ElTreeV2
